import type { TOC } from '@ember/component/template-only';
import { PrismCard } from '@mylighthouse/prism-ember';

interface HotelMarketInsightCardsCardBreakdownSignature {
  Args: {
    title: unknown;
  };
  Blocks: {
    default: [];
  };
}

const HotelMarketInsightCardsCardBreakdown = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <PrismCard @contentLayout="noPadding" @isSecondary={{true}}>
    <:header as |Header|>
      <Header.title>
        {{@title}}
      </Header.title>
    </:header>
    <:content>
      {{yield}}
    </:content>
  </PrismCard>
</template> satisfies TOC<HotelMarketInsightCardsCardBreakdownSignature>;

export default HotelMarketInsightCardsCardBreakdown;
